import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AbstractComponent} from "../abstract.component";
import {CalendarViewType, EventItem, Lookups} from "@model";
import {LocalStorageService} from "@services";

@Component({
  selector: 'app-event-grid-list',
  templateUrl: './event-grid-list.component.html',
  styleUrl: './event-grid-list.component.scss',
  standalone: false
})
export class EventGridListComponent extends AbstractComponent{
  @Input() events: EventItem[] = [];
  @Input({required: true}) languages: Lookups[] = [];
  @Output() scrolled: EventEmitter<void> = new EventEmitter<void>();
  @Output() onRightButtonClickCallback: EventEmitter<EventItem> = new EventEmitter<EventItem>();

  readonly CalendarViewType = CalendarViewType;
  currentLayout: CalendarViewType = CalendarViewType.LIST;

  constructor(private localStorageService: LocalStorageService) {
    super();
  }

  ngOnInit(): void {
    this.updateLayout();
    this.subscriptions.push(
        this.isMobile$.subscribe(() => this.updateLayout()),
        this.isMdScreen$.subscribe(() => this.updateLayout()),
        this.localStorageService.currentLayout$.subscribe(() => this.updateLayout())
    );
  }

  private updateLayout(): void {
    this.currentLayout = this.isMdScreen || this.isMobile ? CalendarViewType.GRID : this.localStorageService.currentLayout;
  }


}
